export enum ButtonSize {
  Small = 'small',
  // The onBackground button size is used for buttons on a complex background, such as image
  OnBackground = 'onbackground',
  Normal = 'normal',
  Medium = 'medium',
  Large = 'large',
}
